module.exports = __webpack_public_path__ + "assets/images/waternormals-4418dde3f6abc21dc32506acf5f5b093.jpg";